// extracted by css-extract-rspack-plugin
export default {"frame":"frame-IBeUw_","fallback":"fallback-Ho70ex"};